<template>
  <section id="realisations" class="realisations container">
    <header>
      <h1>Réalisations</h1>
      <Select
        :options="[
          {
            name: 'En cours',
            value: 'in-progress',
          },
          {
            name: 'Habitations',
            value: 'habitations',
          },
          {
            name: 'Transformations',
            value: 'transformations',
          },
          {
            name: 'Immeubles à appartements',
            value: 'building',
          },
          {
            name: 'Programmes mixtes',
            value: 'mix',
          },
        ]"
        v-model="currentCategory"
      ></Select>
      <div class="tabs">
        <ul class="d-flex">
          <li>
            <button :class="currentCategory === 'in-progress' ? 'active' : null" @click="filterCategory('in-progress')">
              En cours
            </button>
          </li>
          <li>
            <button :class="currentCategory === 'habitations' ? 'active' : null" @click="filterCategory('habitations')">
              Habitations
            </button>
          </li>
          <li>
            <button
              :class="currentCategory === 'transformations' ? 'active' : null"
              @click="filterCategory('transformations')"
            >
              Transformations
            </button>
          </li>
          <li>
            <button :class="currentCategory === 'building' ? 'active' : null" @click="filterCategory('building')">
              Immeubles à appartements
            </button>
          </li>
          <li>
            <button :class="currentCategory === 'mix' ? 'active' : null" @click="filterCategory('mix')">
              Programmes Mixtes
            </button>
          </li>
        </ul>
      </div>
      <transition-group name="list" tag="div" class="works d-flex">
        <div class="work" v-for="work in worksToDisplay" :key="work.id">
          <div class="overflow">
            <div
              class="img-container"
              :style="{
                background: 'url(' + work.thumbnail + ')',
                'background-position': 'center center',
                'background-size': 'cover',
              }"
              :key="work.id"
              @click="openModal(work.id)"
            >
              <img :src="work.url" alt="" :key="work.id" />
            </div>
          </div>
        </div>
      </transition-group>
      <transition name="list" tag="div">
      <div v-if="worksToDisplay.length === 0"><strong>Pas de biens correspondants</strong></div>
      </transition>
    </header>
  </section>
</template>

<script>
import EventBus from "@/bus/modal-bus";
import Select from "./core/Select";

export default {
  name: "Realisations",
  props: ["works"],
  components: {
    Select,
  },
  data() {
    return {
      worksToDisplay: [],
      currentCategory: "",
    };
  },
  watch: {
    works(e) {
      this.worksToDisplay = e.filter((el) => {
        if (el.category.includes(this.currentCategory)) return el;
        return false;
      });
    },
    currentCategory(){
      this.worksToDisplay = this.works.filter((el) => {
        if (el.category.includes(this.currentCategory)) return el;
        return false;
      });
    }
  },
  methods: {
    filterCategory(category) {
      this.currentCategory = category;
      this.worksToDisplay = this.works.filter((el) => {
        if (el.category.includes(this.currentCategory)) return el;
        return false;
      });
    },
    openModal(selector) {
      EventBus.$emit("change_modal", {
        modal: true,
        properties: this.worksToDisplay.filter((el) => el.id === selector),
      });
    },
  },
  created() {
    this.filterCategory("in-progress");
  },
};
</script>

<style>
.list-leave-active {
  transition: all 0.25s;
}

.list-enter-active {
  transition: all 0.25s;
  transition-delay: 0.25s;
}

.list-enter {
  opacity: 0;
  transform: translateY(-30px);
}

.list-leave-to /* .list-leave-active for <2.1.8 */
 {
  opacity: 0;
  transform: translateY(30px);
}
</style>
